import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class ItemsDTO {
  @ApiProperty()
  itemId: number;

  @ApiProperty()
  @IsNotEmpty()
  @MaxLength(255) // Adjust the maximum length as per your database schema
  item: string;

  @ApiProperty()
  @IsNotEmpty()
  consumptionrequired: boolean;

  @ApiProperty()
  @IsNotEmpty()
  consumption: number;


  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  @IsOptional()
  createdAt?: Date;

  @ApiProperty()
  createdUser: string;

  @ApiProperty()
  @IsOptional()
  updatedAt?: Date;
 
  @ApiProperty()
  updatedUser: string;

  @ApiProperty()
  versionFlag: number;

  @ApiProperty()
  isOrderFormRequired: boolean;

}
